import axios from 'axios'
import qs from 'qs'
import * as Util from 'common/js/util'
/**
 * ajax请求
 * @param  {[type]} url  [description]
 * @param  {[type]} data [description]
 * @return {[type]}      [description]
 */
export function http (url, data, au) {
  data = Object.assign({
    requestInfo: {systemName: 'TO_PRIVATE_APP'}
  }, data)
  // console.log(data)
  let aesData = ''
  console.log(`上行:${url};au:${au}`, data)
  const timestamp = Util.uuid() + '-' + Util.getTimeStamp()
  aesData = Util.enctypeAes(data, timestamp)
  aesData = Util.encryptBase64(aesData)
  return new Promise((resolve, reject) => {
    axios({
      url: url,
      method: 'post',
      timeout: 100000,
      data: {body: aesData},
      headers: Util.authorization(timestamp, aesData, au),
      transformRequest: [(data) => {
        data = qs.stringify(data)
        return data
      }],
      transformResponse: [(data) => {
        // Base64 转码
        data = Util.decryptBase64(data)
        // aes 解密
        data = Util.dectyptAES(data)
        console.log('下行：' + url, JSON.parse(data))
        return JSON.parse(data)
      }]
    }).then((res) => {
      resolve(res.data)
    }).catch((e) => {
      reject(e)
    })
  })
}



// WEBPACK FOOTER //
// ./src/common/js/http.js